export default __webpack_public_path__ + "static/logo-vevol-media-4c0e9828c6e115160d4d2213dfaa44d8.svg";